import { defineStore } from 'pinia';

export const useValidaForm = defineStore('counter', {
  state: () => ({
    countObrigatorio: 0,
    countPreenchidos: 0,
  }),
});
